import React from 'react'
import PropTypes from 'prop-types'
import './UnitMix.scss'
import Comps from '@engine/comps'
import { connect } from 'react-redux'
import { formatNumber } from '@engine/utils/format'
import { EditButtonWrapper } from '@components/common'
import { EditUnitMixDetails } from '@components/custom'
import { SALES_COMPARABLES } from '@engine/dependencies/constants'
export class UnitMix extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isDialogOpen: false
    }
  }

  handleEditButtonClick = () => {
    this.setState({
      isDialogOpen: !this.state.isDialogOpen
    })
  }

  handleColumnsDoneDialog = data => {
    this.props.editColumnsDetails({ unitMixTableColumns: data })
  }

  render() {
    const {
      comparableData,
      unitMixPercantage,
      propertyType,
      themeColors,
      unitMixCount,
      unitMixTableColumns,
      templateName,
      editUnitMixData,
      hideUnitMixTotal,
      togglePropertyWeightedAvg,
      toggleSettings: { templateType },
      unitMixDisclaimerData
    } = this.props

    const comparableDataTemplateWise = [...comparableData]
    if (comparableDataTemplateWise.length > unitMixCount) {
      const comparableDataTotal = comparableDataTemplateWise.pop()
      comparableDataTemplateWise.splice(unitMixCount)
      comparableDataTemplateWise.push(comparableDataTotal)
    }
    if (hideUnitMixTotal) {
      comparableDataTemplateWise.pop()
    }

    const unitmix_attr_to_be_displayed = unitMixTableColumns
      ?.filter(obj => obj.value !== 'NA')
      .map(obj => obj.value)
    const headingStyle = propertyType?.toString().includes('S')
      ? {
        color: themeColors.subjectSectionHeadingColor
      }
      : {
        color: themeColors.comparableSectionHeadingColor
      }

    return (
      <div data-testid="unite-mix" className="unite-mix">
        {!templateName.includes(SALES_COMPARABLES) ? (
          <>
            <EditButtonWrapper
              handleEditButtonClick={this.handleEditButtonClick}
              dataTestId="edit-unitmix-button"
              isTruncated={comparableData.filter(obj => !obj.isRemoved)?.length > unitMixCount}
            >
              <div className="unite-mix__table">
                <table>
                  <tbody>
                    <tr className="border-th">
                      {unitMixTableColumns.map((obj, index) =>
                        (obj.key !== 'NA' ? <th key={index}>{obj.key}</th> : null)
                      )}
                    </tr>
                    {comparableDataTemplateWise &&
                      comparableDataTemplateWise
                        .filter(row => !row.isRemoved)
                        .map((row, index) => (
                          <tr
                            key={index}
                            className={
                              (comparableDataTemplateWise.length - 1 === index && !hideUnitMixTotal)
                                ? 'total'
                                : comparableDataTemplateWise.length - 1 === index ? '' : 'border_bottom'
                            }
                          >
                            {unitmix_attr_to_be_displayed.map((key, idx) => {
                              let tdElement = ''
                              if (key === 'unitType') {
                                tdElement =
                                  row.unitType === 'NA' ? (
                                    <td key={idx}>{'WT AVG.'}</td>
                                  ) : (
                                    <td key={idx}>
                                      {row.unitType.replace(/[a-z A-Z]/g, '')}
                                    </td>
                                  )
                              } else if (key === 'comments') {
                                tdElement = (
                                  <td key={idx}>{row.comments.slice(0, 10)}</td>
                                )
                              } else {
                                tdElement = (
                                  <td key={idx}>
                                    {formatNumber(key, row[key])}
                                  </td>
                                )
                              }

                              return tdElement
                            })}
                          </tr>
                        ))}
                  </tbody>
                </table>
              </div>
              {unitMixDisclaimerData && unitMixDisclaimerData?.showDisclaimer && (
                <div className="unit-mix_disclaimer-text">{unitMixDisclaimerData?.disclaimerText}</div>
              )}
            </EditButtonWrapper>
            {this.state.isDialogOpen ? (
              <EditUnitMixDetails
                templateType={templateType}
                isDialogOpen={this.state.isDialogOpen}
                closeEditPopup={this.handleEditButtonClick}
                doneColumnsDialog={this.handleColumnsDoneDialog}
                unitMixTableColumns={unitMixTableColumns}
                comparableData={comparableData}
                rowsCount={unitMixCount}
                propertyType={propertyType}
                editUnitMixData={editUnitMixData}
                hideUnitMixTotal={hideUnitMixTotal}
                togglePropertyWeightedAvg={togglePropertyWeightedAvg}
                unitMixDisclaimerData={unitMixDisclaimerData}
              />
            ) : (
              ''
            )}
          </>
        ) : (
          <div className="unit-mix-data">
            <div className="unit-mix-data__heading" style={headingStyle}>
              UNIT MIX
            </div>
            <div className="unit-mix-data__unittype">
              {unitMixPercantage &&
                Object.keys(unitMixPercantage)
                  .sort()
                  .slice(0, unitMixCount)
                  .map((unitType, index) => (
                    <span key={index}>{`${unitType.includes('0 Bedroom')
                      ? 'Studio'
                      : unitType.replace('Bedroom', 'Bed')
                      } - ${unitMixPercantage[unitType]}%`}</span>
                  ))}
            </div>
          </div>
        )}
      </div>
    )
  }
}

UnitMix.propTypes = {
  comparableData: PropTypes.array,
  templateName: PropTypes.string,
  unitMixPercantage: PropTypes.object,
  propertyType: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  hideUnitMixTotal: PropTypes.bool,
  themeColors: PropTypes.object,
  unitMixCount: PropTypes.number,
  unitMixTableColumns: PropTypes.array,
  editColumnsDetails: PropTypes.func,
  editUnitMixData: PropTypes.func,
  togglePropertyWeightedAvg: PropTypes.func,
  toggleSettings: PropTypes.shape({
    templateType: PropTypes.string,
    hasBranding: PropTypes.bool,
    hasNotes: PropTypes.bool,
    hasAmenities: PropTypes.bool
  }),
  unitMixDisclaimerData: PropTypes.object
}

const mapStateToProps = state => ({
  themeColors: Comps.selectors.comps.themeColors(state),
  unitMixTableColumns: Comps.selectors.comps.unitMixTableColumns(state),
  templateName: Comps.selectors.comps.templateName(state),
  toggleSettings: Comps.selectors.comps.toggleSettings(state)
})

const mapDispatchToProps = {
  editColumnsDetails: Comps.actions.editColumnsDetails,
  editUnitMixData: Comps.actions.editUnitMixData,
  togglePropertyWeightedAvg: Comps.actions.togglePropertyWeightedAvg
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UnitMix)
